import React from "react";

function About() {
  return (
    <div id="about" className="about-section">
      <div className="about-container">
        <div className="about-photo">
          <img src="formal_photo.jpg" alt="Profile" className="photo" />
        </div>
        <div className="bio-container">
          <h1>Hey, I'm Ada!</h1>
          <h3>
            I am a Computer Science student at the
            <a
              href="https://www.utoronto.ca/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              University of Toronto.{" "}
            </a>
          </h3>
          <h3>
            My main interests are systems programming, firmware engineering,
            robotics, and psychology.
          </h3>
          <h3>
            {" "}
            I have been participating and volunteering for robotics programs for
            over 9 years. If I can be helpful or you'd like to chat, please
            <a href="mailto:nevinada.cakmak@mail.utoronto.ca"> reach out.</a>
          </h3>
        </div>
      </div>
    </div>
  );
}

export default About;
